/**
 * Die Wohnung eines Bewohners — `/wohnung/{unitId}` (HM-081, HM-083, ADR 0026 §3).
 * „Laden" steht daneben in `routes/charging.tsx` (HM-119).
 *
 * **Dieselbe Ansicht wie an der Wohneinheit des Vermieters**: „Strom" mit
 * Kennzahlen, Verlauf, Leistung und Zählern (`UnitElectricityView`) — nur ohne
 * den Weg zum Messkonzept, das dem Vermieter gehört. Was der Bewohner sieht, ist
 * auf seine Bewohnung beschnitten; der Server sagt es über `occupancy` und
 * `clipped`, die Komponente erklärt es.
 *
 * **Eine Übersicht davor gibt es nicht mehr** (HM-156): Sie zeigte dieselben
 * Größen knapper, und die Kachel des Ladepunkts darauf ist der Eintrag „Laden"
 * in der Leiste — der steht nur, wo es einen Ladepunkt gibt.
 */
import { Card, EmptyState, icons } from "@hausmeter/ui";
import type { EnergyPeriod } from "../lib/router.js";
import { useMyUnits } from "../lib/queries.js";
import { UnitElectricityView } from "./unit-electricity.js";

export function ResidentUnitScreen({
  unitId,
  period,
  date,
}: {
  unitId: string;
  period: EnergyPeriod;
  date: string | null;
}) {
  const units = useMyUnits();
  const unit = units.data?.units.find((entry) => entry.siteAreaId === unitId) ?? null;

  if (units.isPending) return <Card padding="sm">Wird geladen …</Card>;
  if (unit === null) {
    return (
      <Card>
        <EmptyState title="Diese Wohnung gehört nicht zu dir" icon={<icons.IconDoor size={30} />}>
          Du siehst nur Wohnungen, in die du eingeladen wurdest. Ist das ein Irrtum, bitte
          den Vermieter um eine Einladung an deine E-Mail-Adresse.
        </EmptyState>
      </Card>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20, maxWidth: 1100 }}>
      <UnitElectricityView siteAreaId={unit.siteAreaId} unitName={unit.unitName} period={period} date={date} timeZone={unit.siteTimezone} />
    </div>
  );
}
